<template>
	<div class="table-map">
		<div class="table-title">
			标站数据表
			<el-button 
				@click="closeTable"
				type="primary" 
				icon="el-icon-close" 
				circle 
				size="mini" 
				style="position: absolute;right: 5px;top: 5px">
			</el-button>
		</div>
		<div class="table-content">
			<div class="table-export">
				<el-input
					size="small"
			    placeholder="请输入名称搜索"
			    prefix-icon="el-icon-search"
			    v-model="searchVal"
			    width="200px"
			    style="width: 200px">
			  </el-input>
				<el-button @click="exportTable" type="primary" size="mini" style="float: right;">导出</el-button>	
			</div>
			<el-table
		    :data="tableFiltered"
		    height="500"
		    border
		    size="small"
		    style="width: 100%">

		    <el-table-column
		      label="#"
		      type="index">
		    </el-table-column>

		    <el-table-column
		    	width="100"
		      label="标站名称"
		      >
		      <template slot-scope="scope">
		        <a style="cursor: pointer;" @click="toPoint(scope.row)">{{ scope.row.name }}</a>
		      </template>
		    </el-table-column>

		    <el-table-column
		    	width="100"
		      label="标站等级"
		      prop="station_level">
		    </el-table-column>
		    
		    <el-table-column
		      :label="name_options[data_type]"
		      width="100">
		      <template slot-scope="scope">
		        <p>{{ validFilter(scope.row.data[data_type]) }}</p>
		      </template>
		    </el-table-column>

			</el-table>
		</div>
		
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FileSaver from '@/utils/plugins/FileSaver'
import { name_options } from '@/options/option'
// import { validFilter } from '@/utils/util'
export default {
	data () {
		return {
			searchVal: '',
			search:'',
			name_options,
		}
	},
	computed: {
		...mapState(['cur_time',]),
		tableFiltered() {
			return this.tableData.filter(
				data => !this.searchVal || 
				data.name.toLowerCase().includes(this.searchVal.toLowerCase())
			)
		}
	},
	props:{
		tableData: Array,
        data_type: String,
        isPollution: Boolean
    },
	methods: {
        validFilter(val) {
            if(this.isPollution) {
                return val >=0 ? val : '--'
            } else {
                return val > 0 ? val : '--'
            }
        },
		// validFilter,
		closeTable() {
			this.$emit("closeTable")
		},
		toPoint(info) {
			this.$emit("toPoint",info)
		},
		exportTable() {
			// var content = [`序号, 道路名称, 路段中心位置, 街镇, 区县, PM₁₀, PM₂.₅, 数据量, 百度街镇, 百度区县\n`];
			var content = [`序号, 标站名称, 标站等级, ${this.name_options[this.data_type]}\n`];
			for (let i in this.tableFiltered){
				let info = this.tableFiltered[i]
				let val = this.validFilter(info.data[this.data_type])
					let text = `${parseInt(i)+1}, ${info.name}, ${info.station_level}, ${val}\n`
				content.push([text])
			}
    		var file_name = '标站数据' + this.cur_time
			var blob = new Blob(content, { type: "text/plain;charset=utf-8" });
			FileSaver.saveAs(blob, file_name + ".csv");
		}
	}
}
</script>

<style>

.table-map {
	position: absolute;
	top: 0;
	z-index: 100;
	width: auto;
	border: 1px solid black;
	background: white;
	margin-left: 470px;
	margin-top: 0px;
	border-radius: 10px
}

.table-title{
	color: white;
	font-size: 18px;
	height: 40px;
	line-height: 40px;
	background: #1891ff;
	padding-left: 20px;
	border-radius: 10px 10px 0 0 
}

.table-content{
	padding:10px 10px;

}

.table-export {
	margin-bottom: 5px;
	position: relative;
	height: 30px;
	line-height: 30px
}
</style>


// WEBPACK FOOTER //
// src/components/common/GfStationTable.vue